// export class ActivoFijoVisitanteModel {

//     public idActivoFijoVisitante: number ;
// 	public tipoDocVisitante: string;	
// 	public numDocVisitante: string;	
// 	public descripcion: string;	
// 	public estado: string;	
// 	public tipo: string;	
// 	public marca: string;	
// 	public numeroSerial: string;	
// 	public tipoTecnologia: string;

//     constructor(){}

// }
export class ActivoFijoVisitanteModel {

  public idActivoFijoVisitante: number;
  public tipoDocVisitante: string;
  public numDocVisitante: string;
  public descripcion: string;
  public estado: string;
 
  public marca: string;
  public numeroSerial: string;
  public tipoTecnologia: string;
  public tipo?: string;

  constructor() { }

}
